export const PROVIDER_CONFIG = {
  dev: {
    CertibleGmbH: {
      name: "Certible GmbH",
      taxSystem: "eu",
      stripePk: "pk_test_i2rvDZClJsDrNOYnko1amGzm",
      stripeCountry: "AT",
      collectBillingAddress: false,
      paymentMethods: {
        stripe: true,
        invoice: true,
      },
    },
    CertibleInc: {
      name: "Certible Inc",
      taxSystem: "us",
      stripePk:
        "pk_test_51PySSoLrIJQn5nlaUW2Ix5lIfBqQdhswd1rYqQPaXoIlNU28FHmYExxRBY3lastUrC6BAazvHSvw37SSINNs998U00ktOM3Ecb",
      stripeCountry: "US",
      collectBillingAddress: true,
      paymentMethods: {
        stripe: true,
        invoice: false,
      },
    },
    CertibleGmbHNonEU: {
      name: "Certible GmbH",
      taxSystem: "eu",
      stripePk: "pk_test_i2rvDZClJsDrNOYnko1amGzm",
      stripeCountry: "AT",
      collectBillingAddress: false,
      paymentMethods: {
        stripe: true,
        invoice: false,
      },
    },
  },
  staging: {
    CertibleGmbH: {
      name: "Certible GmbH",
      taxSystem: "eu",
      stripePk: "pk_test_i2rvDZClJsDrNOYnko1amGzm",
      stripeCountry: "AT",
      collectBillingAddress: false,
      paymentMethods: {
        stripe: true,
        invoice: true,
      },
    },
    CertibleInc: {
      name: "Certible Inc",
      taxSystem: "us",
      stripePk:
        "pk_test_51PySSoLrIJQn5nlaUW2Ix5lIfBqQdhswd1rYqQPaXoIlNU28FHmYExxRBY3lastUrC6BAazvHSvw37SSINNs998U00ktOM3Ecb",
      stripeCountry: "US",
      collectBillingAddress: true,
      paymentMethods: {
        stripe: true,
        invoice: false,
      },
    },
    CertibleGmbHNonEU: {
      name: "Certible GmbH",
      taxSystem: "eu",
      stripePk: "pk_test_i2rvDZClJsDrNOYnko1amGzm",
      stripeCountry: "AT",
      collectBillingAddress: false,
      paymentMethods: {
        stripe: true,
        invoice: false,
      },
    },
  },
  prod: {
    CertibleGmbH: {
      name: "Certible GmbH",
      taxSystem: "eu",
      stripePk: "pk_live_lfCh89ED01LmQb41g7E9BCsC",
      stripeCountry: "AT",
      collectBillingAddress: false,
      paymentMethods: {
        stripe: true,
        invoice: true,
      },
    },
    CertibleInc: {
      name: "Certible Inc",
      taxSystem: "us",
      stripePk:
        "pk_live_51PySSoLrIJQn5nla6gqZpgEBMU7N8OL2sQHiJikyxnvBkxrYLWX6884pA8Gn1jnCfPBcURjIS3aarz7XeTn7H5if007LOPNlmX",
      stripeCountry: "US",
      collectBillingAddress: true,
      paymentMethods: {
        stripe: true,
        invoice: false,
      },
    },
    CertibleGmbHNonEU: {
      name: "Certible GmbH",
      taxSystem: "eu",
      stripePk: "pk_live_lfCh89ED01LmQb41g7E9BCsC",
      stripeCountry: "AT",
      collectBillingAddress: false,
      paymentMethods: {
        stripe: true,
        invoice: false,
      },
    },
  },
};
